<template>
    <DialogContent id="notification-preview" class="">
        <template v-if="step == 'choose'">
            <DialogHeader>
                <DialogTitle>{{ $t("Notifications.NotificationPreviewHeader") }}</DialogTitle>
            </DialogHeader>
            <div class="text-base">
                {{ $t("Notifications.NotificationPreviewDesc") }}
                <a :href="sampleEmailUrl" rel="noopener" target="_blank">
                    {{ $t("Notifications.SeeASample") }}
                </a>
            </div>
            <div class="text-base" v-html="$t('Notifications.NotificationPreviewSignIn')" />
            <div class="flex flex-row gap-4">
                <Button variant="primary" fill="solid" @click="startLogin">
                    {{ $t("SignIn.LoginButtonText") }}
                </Button>
                <Button variant="primary" as="a" :href="registerUrl">
                    {{ $t("Register.RegisterTitle") }}
                </Button>
            </div>
        </template>
        <template v-else-if="step == 'login'">
            <DialogHeader>
                <DialogTitle>{{ $t("SignIn.LoginButtonText") }}</DialogTitle>
            </DialogHeader>
            <LoginForm @success="continueLogin" />
        </template>
    </DialogContent>
</template>

<script setup lang="ts">
const { gtag } = useGtag();
const config = useRuntimeConfig();
const localePath = useLangPath();

const emit = defineEmits<{ continue: [isAuthenticated: boolean] }>();

const step = ref<"choose" | "login">("choose");
const registerUrl = localePath("/register");
const sampleEmailUrl = config.public.cdnUrl + "/assets/images/sample-alert-email.pdf";

function startLogin() {
    gtag("event", "sign_in_modal_sign_in");
    step.value = "login";
}

async function continueLogin() {
    emit("continue", true);
}
</script>
